<template>
  <QSwitchInput
    v-model="localValue"
    :label="label"
    externaledit
  />
</template>

<script>
import QSwitchInput from "@/components/Inputs/QSwitchInput.vue";

export default {
  name: "QAIFieldBoolean",
  components: { QSwitchInput },
  props: {
    value: { type: Boolean, default: false },
    definition: { type: Object, required: true },
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(v) { this.$emit("input", !!v); },
    },
    label() {
      return this.definition.Description || this.definition.Name;
    },
  },
};
</script>
